import React from 'react';
import {
    ArrayField,
    Datagrid,
    ReferenceManyField,
    ShowController,
    ShowView,
    Tab,
    TabbedShowLayout,
    TextField } from 'react-admin';
import UserField from './UserField';

const ConfigTitle = ({ record }) => {
    return <span style={{ marginLeft: 16}}>{record ? `${record.CustomerName} - ${record.CustomerConfigDescription} ` : ''}</span>;
};

export const ConfigShow = props => (
    <ShowController   {...props}>
        {controllerProps =>
            <ShowView title={<ConfigTitle />} {...props} {...controllerProps}>
                <TabbedShowLayout>
                    <Tab label = "Input">
                        <TextField label="Customer" source="CustomerName"/>
                        <TextField label="Description" source="CustomerConfigDescription"/>
                        <TextField
                            label="Source"
                            source="config.ChannelMix[0].Channel.inputService.source.tsfileSettings.source.fileName"/>
                        <ArrayField label="First screen" source="config.ChannelMix[0].Channel.CBRProcessings">
                            <Datagrid>
                                <TextField
                                    label="codec"
                                    source="videoSettings.codec"/>
                                <TextField
                                    label="Profile"
                                    source="videoSettings.profile"/>
                                <TextField
                                    label="rateMode"
                                    source="videoSettings.rateMode"/>
                                <TextField label="qualityLevel" source="videoSettings.qualityLevel"/>
                                <TextField
                                    label="resolution"
                                    source="videoSettings.resolution"/>
                                <TextField label="esRate" source="videoSettings.esRate" />
                            </Datagrid>
                        </ArrayField>
                        <ArrayField source="config.ChannelMix[0].Channel.ABRProcessings"
                                    label="ABR Settings">
                            <Datagrid>
                                <TextField
                                    label="Processing Delay"
                                    source="serviceSettings.processingDelay"/>
                                <ArrayField label="Video Settings" source="videoSettings.profiles">
                                    <Datagrid>
                                        <TextField
                                            label="codec"
                                            source="codec"/>
                                        <TextField
                                            label="Profile"
                                            source="profile"/>
                                        <TextField
                                            label="rateMode"
                                            source="rateMode"/>
                                        <TextField label="qualityLevel" source="qualityLevel"/>
                                        <TextField
                                            label="hResolution"
                                            source="hResolution"/>
                                        <TextField
                                            label="vResolution"
                                            source="vResolution"/>
                                        <TextField
                                            label="frameRate"
                                            source="frameRate"/>
                                        <TextField label="esRate" source="esRate" />
                                    </Datagrid>
                                </ArrayField>
                            </Datagrid>
                        </ArrayField>
                    </Tab>
                    <Tab label = "Shared with">
                        <p>Share your results with colleagues</p>
                        <UserField addLabel={true} label="Shared with"/>
                    </Tab>
                    <Tab label = "TCO information">
                        <TextField label="Channel Count" source="DeployedChannels"/>
                    </Tab>
                    <Tab label="CPU Estimates">
                        <ReferenceManyField
                            addLabel={false}
                            sort={{ field: 'ListPerChannel', order: 'DESC' }}
                            reference="customerconfigsweep"
                            target={"CustomerConfigId"}
                        >
                            <Datagrid rowClick="show">
                                <TextField source="Virtualization"  />
                                <TextField label="Platform PID" source="PlatformPID"  />
                                <TextField source="CpuType"  />
                                <TextField label="Channel Count" source="DeployedChannels"  />
                                <TextField label="Channels per Server" source="EstimatedDensity"  />
                                <TextField label="Server Count" source="ServerCount"  />
                                <TextField label="List Price per Channel [$]" source="ListPerChannel"  />
                                <TextField label="Power per Channel [W]" source="PowerPerChannel"  />
                                <TextField label="Status" source="CustomerConfigSweepStatus"  />
                            </Datagrid>
                        </ReferenceManyField>

                    </Tab>
                </TabbedShowLayout>
            </ShowView>
        }
    </ShowController>
);

export default (ConfigShow);